import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE = 'https://fortworthdental.com';

/**
 * CanonicalManager — safety net that guarantees every page has a canonical tag.
 * Most pages set their own canonical via react-helmet; this only injects a
 * fallback canonical (current clean URL) when a page hasn't provided one, so we
 * never emit duplicate canonicals. Skips /admin and /api.
 */
const CanonicalManager = () => {
  const location = useLocation();

  useEffect(() => {
    const path = (location.pathname || '/').replace(/\/+$/, '') || '/';
    if (path.startsWith('/admin') || path.startsWith('/api')) return;

    // Let page-level Helmet commit its own canonical first, then fill gaps.
    const id = setTimeout(() => {
      const existing = document.querySelectorAll('link[rel="canonical"]');
      if (existing.length > 0) return; // page already provides one
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = `${SITE}${path}`;
      link.setAttribute('data-canonical-fallback', 'true');
      document.head.appendChild(link);
    }, 350);

    return () => {
      clearTimeout(id);
      // remove our fallback on navigation so it doesn't linger onto the next page
      document
        .querySelectorAll('link[rel="canonical"][data-canonical-fallback="true"]')
        .forEach((el) => el.remove());
    };
  }, [location.pathname]);

  return null;
};

export default CanonicalManager;
